import { useState } from "react";

import colorGreen from "../assets/images/color-green.svg";
import colorRed from "../assets/images/color-red.svg";
import colorViolet from "../assets/images/color-violet.svg";
import colorWhite from "../assets/images/color-white.svg";
import colorYellow from "../assets/images/color-yellow.svg";
import iconErase from "../assets/images/erase.svg";
import iconHighlight from "../assets/images/highlight.svg";
import iconRedo from "../assets/images/redo.svg";
import colorSelect from "../assets/images/select-color.svg";
import iconSelectThickness from "../assets/images/select-thickness.svg";
import thickness1 from "../assets/images/thickness1.svg";
import thickness2 from "../assets/images/thickness2.svg";
import thickness3 from "../assets/images/thickness3.svg";
import thickness4 from "../assets/images/thickness4.svg";
import iconDelete from "../assets/images/trash.svg";
import iconUndo from "../assets/images/undo.svg";

const Whiteboarding = () => {
  const colors = [
    { name: "white", src: colorWhite },
    { name: "red", src: colorRed },
    { name: "yellow", src: colorYellow },
    { name: "green", src: colorGreen },
    { name: "violet", src: colorViolet },
  ];

  const [color, setColor] = useState(colorSelect);
  const [colorName, setColorName] = useState();
  // const [highlight, setHighlight] = useState("");
  // const [thickness, setThickness] = useState("");

  const [showListColors, setShowListColors] = useState(false);
  const [showListHighlight, setShowListHighlight] = useState(false);
  const [showThickness, setShowThickness] = useState(false);

  return (
    <div className="whiteboarding">
      <div className="whiteboarding-contaner">
        {/* color */}
        <div className="whiteboarding-color">
          <img src={`${color}`} className={`btn-${color}`} onClick={() => setShowListColors(!showListColors)} alt="" />
          {showListColors && (
            <div className="whiteboarding-list" id="whiteboarding-color">
              <ul>
                {colors.map((i) => (
                  <li onClick={() => setColorName(i.name)}>
                    <img src={i.src} className={`btn-${i.name}`} onClick={() => setColor(i.src)} alt="" />
                  </li>
                ))}
                <li className="relative">
                  <img src={iconErase} className="btn-erase" alt="" />
                  <div className="tooltip-type2 tooltip-erase">Erase</div>
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* highlight */}
        <div className="whiteboarding-highlight">
          <img src={iconHighlight} className="btn-highlight" onClick={() => setShowListHighlight(!showListHighlight)} alt="" />
          {showListHighlight && (
            <div className="whiteboarding-list" id="whiteboarding-highlight">
              <ul>
                <li>
                  <span> 100% </span>
                  <img
                    src={color}
                    // onClick={() => setHighlight("100")} alt=""
                    alt=""
                  />
                </li>
                <li>
                  <span> 50% </span>
                  <img
                    src={color}
                    className={`btn-${colorName}-opacity-5`}
                    // onClick={() => setHighlight("50")}
                    alt=""
                  />
                </li>
                <li>
                  <span> 20% </span>
                  <img
                    src={color}
                    className={`btn-${colorName}-opacity-2`}
                    // onClick={() => setHighlight("20")}
                    alt=""
                  />
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* thickness */}
        <div className="whiteboarding-thickness">
          <img src={iconSelectThickness} className="btn-thickness" onClick={() => setShowThickness(!showThickness)} alt="" />
          {showThickness && (
            <div className="whiteboarding-list" id="whiteboarding-thickness">
              <ul>
                <li>
                  <img
                    src={thickness1}
                    // onClick={() => setThickness("2px")}
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={thickness2}
                    // onClick={() => setThickness("5px")}
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={thickness3}
                    // onClick={() => setThickness("10px")}
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={thickness4}
                    // onClick={() => setThickness("20px")}
                    alt=""
                  />
                </li>
              </ul>
            </div>
          )}
        </div>

        {/* delete */}
        <div className="whiteboarding-delete">
          <img src={iconDelete} className="btn-delete" alt="" />
        </div>

        {/* redo */}
        <div className="whiteboarding-redo">
          <img src={iconRedo} className="btn-redo" alt="" />
          <div className="tooltip-type2 tooltip-redo">Redo</div>
        </div>

        {/* undo */}
        <div className="whiteboarding-undo">
          <img src={iconUndo} className="btn-undo" alt="" />
          <div className="tooltip-type2 tooltip-undo">Undo</div>
        </div>
      </div>
    </div>
  );
};

export default Whiteboarding;
